// import React, { useEffect, useState } from "react";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import drilldown from "highcharts/modules/drilldown";

// if (typeof Highcharts === "object") {
//   drilldown(Highcharts);
// }

// const Chart = () => {
//   const [selectedMedicareType, setSelectedMedicareType] = useState("PFS");
//   const [selectedCategory, setSelectedCategory] = useState(
//     Object.keys(cignaData["PFS"])[0]
//   );

//   const [chartOptions, setChartOptions] = useState(
//     getChartOptions("PFS", Object.keys(cignaData["PFS"])[0])
//   );

//   useEffect(() => {
//     setChartOptions(getChartOptions(selectedMedicareType, selectedCategory));
//   }, [selectedMedicareType, selectedCategory]);

//   return (
//     <div>
//       {/* Dropdowns */}
//       <div className="mb-4 d-flex flex-row gap-3 align-items-center">
//         {/* Medicare Type Dropdown */}
//         <div>
//           <label className="form-label">Select Medicare Type:</label>
//           <select
//             className="form-select"
//             value={selectedMedicareType}
//             onChange={(e) => {
//               const newType = e.target.value;
//               const defaultCategory = Object.keys(cignaData[newType])[0];
//               setSelectedMedicareType(newType);
//               setSelectedCategory(defaultCategory);
//             }}
//           >
//             {Object.keys(cignaData).map((type) => (
//               <option key={type} value={type}>
//                 {type}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Category Dropdown */}
//         <div>
//           <label className="form-label">Select Category:</label>
//           <select
//             className="form-select"
//             value={selectedCategory}
//             onChange={(e) => setSelectedCategory(e.target.value)}
//           >
//             {Object.keys(cignaData[selectedMedicareType]).map((cat) => (
//               <option key={cat} value={cat}>
//                 {cat}
//               </option>
//             ))}
//           </select>
//         </div>
//       </div>

//       {/* Chart */}
//       <HighchartsReact highcharts={Highcharts} options={chartOptions} />
//     </div>
//   );
// };

// export default Chart;

// const getChartOptions = (medicareType, category) => {
//   const subcategories = cignaData[medicareType][category];

//   const chartData = Object.entries(subcategories).map(
//     ([subcategoryName, networkData]) => {
//       const drilldownId = `${medicareType}-${category}-${subcategoryName}`;
//       return {
//         name: subcategoryName,
//         y: Object.keys(networkData).length,
//         drilldown: drilldownId,
//       };
//     }
//   );

//   const drilldownSeries = Object.entries(subcategories).map(
//     ([subcategoryName, networkData]) => {
//       const drilldownId = `${medicareType}-${category}-${subcategoryName}`;
//       const data = Object.entries(networkData).map(([network, value]) => [
//         network,
//         value,
//       ]);
//       return {
//         id: drilldownId,
//         name: `${subcategoryName} - Network Prices`,
//         data,
//       };
//     }
//   );

//   return {
//     chart: {
//       type: "column",
//     },
//     title: {
//       text: `${category} - ${medicareType}`,
//     },
//     xAxis: {
//       type: "category",
//     },
//     yAxis: {
//       title: {
//         text: "Average Cost",
//       },
//     },
//     legend: {
//       enabled: false,
//     },
//     plotOptions: {
//       series: {
//         borderWidth: 0,
//         dataLabels: {
//           enabled: true,
//           format: "{point.y:.0f}",
//         },
//       },
//     },
//     tooltip: {
//       headerFormat: "<span style='font-size:11px'>{series.name}</span><br>",
//       pointFormat:
//         "<span style='color:{point.color}'>{point.name}</span>: <b>{point.y}</b><br/>",
//     },
//     series: [
//       {
//         name: "Procedure Type",
//         colorByPoint: true,
//         data: chartData,
//       },
//     ],
//     drilldown: {
//       series: drilldownSeries,
//     },
//   };
// };

// const cignaData = {
//   PFS: {
//     "Medicine Services and Procedures": {
//       "Neurology and Neuromuscular Procedures": {
//         "Cigna National OAP": 127.73,
//         "Cigna National PPO SAR II": 127.73,
//         "Cigna Priority Health Alliance": 127.73,
//         "Cigna MVP Mohawk Valley Physicians": 127.73,
//         "Cigna Carelink": 127.73,
//         "Cigna Pathwell Carelink National OAP": 127.73,
//       },
//     },
//     "Radiology Procedures": {
//       "Breast, Mammography": {
//         "Cigna Localplus": 140.65,
//         "Cigna Healthpartners Qualified": 140.65,
//         "Cigna Health Care Alliance of the Front Range": 140.65,
//       },
//       "Diagnostic Radiology (Diagnostic Imaging) Procedures": {
//         "Cigna Priority Health Alliance": 483.51,
//         "Cigna National PPO": 483.51,
//       },
//     },
//     "Evaluation and Management": {
//       "Office or Other Outpatient Services": {
//         "Cigna Tennesse Connect": 3018.99,
//         "Cigna NC Connect HMO": 3018.99,
//         "Cigna MS IFP Connect": 3018.99,
//         "Cigna MVP Mohawk Valley Physicians": 3018.99,
//       },
//     },
//   },
// };

import React, { useEffect, useState, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import drilldown from "highcharts/modules/drilldown";

if (typeof Highcharts === "object") {
  drilldown(Highcharts);
}

// Sample cignaData
const cignaData = {
  PFS: {
    "Medicine Services and Procedures": {
      "Neurology and Neuromuscular Procedures": {
        "Cigna National OAP": 127.73,
        "Cigna National PPO SAR II": 127.73,
        "Cigna Priority Health Alliance": 127.73,
        "Cigna MVP Mohawk Valley Physicians": 127.73,
        "Cigna Carelink": 127.73,
        "Cigna Pathwell Carelink National OAP": 127.73,
      },
    },
    "Radiology Procedures": {
      "Breast, Mammography": {
        "Cigna Localplus": 140.65,
        "Cigna Healthpartners Qualified": 140.65,
        "Cigna Health Care Alliance of the Front Range": 140.65,
      },
      "Diagnostic Radiology (Diagnostic Imaging) Procedures": {
        "Cigna Priority Health Alliance": 483.51,
        "Cigna National PPO": 483.51,
      },
    },
    "Evaluation and Management": {
      "Office or Other Outpatient Services": {
        "Cigna Tennesse Connect": 3018.99,
        "Cigna NC Connect HMO": 3018.99,
        "Cigna MS IFP Connect": 3018.99,
        "Cigna MVP Mohawk Valley Physicians": 3018.99,
      },
    },
  },
  DrugB: {
    "Chemotherapy Drugs": {
      "Chemotherapy Drugs": {
        "Cigna National OAP": 434.32,
        "Cigna Pathwell Carelink National OAP": 434.32,
        "Cigna MVP Mohawk Valley Physicians": 434.32,
      },
    },
  },
};

const colorPalette = ["#c0e7e7", "#feb187", "#d1e8ff", "#ffd29f", "#507a8a"];

const processData = (data) => {
  const seriesData = [];
  const drilldownSeries = [];

  Object.entries(data).forEach(([subcategory, networks], subIndex) => {
    const subcategoryId = subcategory.replace(/\s+/g, "-");

    const value = Object.values(networks)[0];

    seriesData.push({
      name: subcategory,
      y: value,
      drilldown: subcategoryId,
      color: colorPalette[subIndex % colorPalette.length],
    });

    const networkData = Object.entries(networks).map(([network, value]) => [
      network,
      value,
    ]);
    drilldownSeries.push({
      id: subcategoryId,
      name: `${subcategory} - Network Prices`,
      data: networkData,
    });
  });

  return { seriesData, drilldownSeries };
};

// Dynamically assign fixed colors to each Medicare type
const medicareTypeColorMap = {
  PFS: "#c0e7e7", // pink
  DrugB: "#507a8a", // red
};

// Fallback palette for future dynamic Medicare types
const fallbackColors = ["#a2d2ff", "#ffd6a5", "#caffbf", "#bdb2ff", "#ffadad"];

const getColorForMedicareType = (type, index) => {
  if (medicareTypeColorMap[type]) {
    return medicareTypeColorMap[type];
  } else {
    return fallbackColors[index % fallbackColors.length];
  }
};

const getChartOptions = (medicareType, category) => {
  const subcategories = cignaData[medicareType]?.[category];
  if (!subcategories) return {};

  const { seriesData, drilldownSeries } = processData(subcategories);

  const color = getColorForMedicareType(
    medicareType,
    Object.keys(cignaData).indexOf(medicareType)
  );

  // Apply uniform color to all bars
  const uniformColoredData = seriesData.map((item) => ({
    ...item,
    color: color,
  }));

  return {
    chart: {
      type: "column",
      events: {
        load() {
          const chart = this;

          if (!chart.customChip) {
            chart.customChip = chart.renderer
              .label(
                "Drill to Network Comparison",
                chart.chartWidth - 230,
                0,
                "rect",
                40,

                40,
                true
              )
              .attr({
                fill: "#f0f0f0", // background color
                padding: 10,
                r: 4, // border radius
                zIndex: 10,
                width: 160,
                stroke: "#ccc", // border color
                "stroke-width": 0.5, // border thickness
                display: "flex", // flexbox for centering
                justifyContent: "center",
                alignItems: "center",
              })
              .css({
                color: "#333",
                fontSize: "12px",
                fontFamily: "'Roboto Flex', sans-serif",
                textAlign: "center",
                fontWeight: "500",
              })
              .add();
          }
        },
        drilldown() {
          const chart = this;
          if (chart.customChip) {
            chart.customChip.attr({
              text: "Drill to Subcategory",
              x: chart.chartWidth - 230,
              y: 0,
            });
          }
        },
        drillup() {
          const chart = this;
          if (chart.customChip) {
            chart.customChip.attr({
              text: "Drill to Network Comparison",
              x: chart.chartWidth - 230,
              y: 0,
            });
          }
        },
        redraw() {
          // Reposition chip on resize
          const chart = this;
          if (chart.customChip) {
            chart.customChip.attr({
              x: chart.chartWidth - 230,
              y: 0,
            });
          }
        },
      },
    },
    title: {
      text: `${medicareType}: ${category}`,
    },
    xAxis: {
      type: "category",
      style: {
        fontSize: "12px",
        fontWeight: "light",
        fontFamily: "'Roboto Flex', serif !important",
      },
    },
    yAxis: {
      title: {
        text: "% of Medicare",
        style: {
          // color: "#555555",
          fontSize: "12px",
          fontFamily: "'Roboto Flex', serif !important",
          letterSpacing: "-0.75px",
        },
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        states: {
          hover: {
            brightness: -0.2, // darken
          },
        },
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: "{point.y:.2f}",
          style: {
            color: "#555555",
            cursor: "pointer",
            border: "none",
            fontWeight: 500,
            fontSize: "12px",
            fontFamily: "'Roboto Flex', serif !important",
            textDecoration: "none",
          },
        },
      },
    },
    exporting: { enabled: false },
    tooltip: {
      headerFormat:
        '<span style="font-size: 14px; color: #5A5A5A;  max-width: 250px; white-space: normal; word-wrap: break-word;">{point.key}</span><br>' +
        '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
      pointFormat:
        "<div style='display:flex; flex-direction:row, align-items: center', justify-content: 'space-between'  ><div style='margin-right: 0px; width:200px; white-space: normal; word-wrap: break-word;'> {series.name} </div> <div style=' display: flex;  justify-content: right; !important; width: 80px; '><b>{point.y}%</b></div> </div>",
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: "#A9A9A9",
      borderRadius: 7,
      animation: false,
      hideDelay: 0,
      style: {
        color: "#333",
        fontFamily: "'Roboto Flex', serif",
        transition: "none",
        fontSize: "12px",
        padding: "8px",
        shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
        zIndex: 99999,
      },
      shadow: true,
      useHTML: true,
      outside: true,
    },
    series: [
      {
        name: "Procedure Type",
        colorByPoint: false,
        data: uniformColoredData,
      },
    ],
    drilldown: {
      series: drilldownSeries,
      activeAxisLabelStyle: {
        color: "#555555",
        cursor: "pointer",
        fontWeight: "normal",
        fontSize: "11px",
        fontFamily: "'Roboto Flex', serif !important",
        textDecoration: "none",
      },
      activeDataLabelStyle: {
        color: "#555555",
        cursor: "pointer",
        border: "none",
        fontWeight: 500,
        fontSize: "12px",
        fontFamily: "'Roboto Flex', serif !important",
        textDecoration: "none",
      },
      breadcrumbs: {
        position: {
          align: "left",
          fontFamily: "'Roboto Flex', serif !important",
        },
        buttonTheme: {
          fill: "#fff",
          stroke: "#ccc",
          style: {
            color: "#333",
          },
        },
      },
    },
  };
};

// const getChartOptions = (medicareType, category) => {
//   const subcategories = cignaData[medicareType]?.[category];
//   if (!subcategories) return {};

//   const { seriesData, drilldownSeries } = processData(subcategories);

//   return {
//     chart: {
//       type: "column",
//     },
//     title: {
//       text: `${medicareType}: ${category}`,
//     },
//     xAxis: {
//       type: "category",
//     },
//     yAxis: {
//       title: {
//         text: "% of Medicare",
//       },
//     },
//     legend: {
//       enabled: false,
//     },
//     plotOptions: {
//       series: {
//         states: {
//           hover: {
//             brightness: -0.4, // darken
//           },
//         },
//         borderWidth: 0,
//         dataLabels: {
//           enabled: true,
//           format: "{point.y:.2f}",
//         },
//       },
//     },
//     tooltip: {
//       headerFormat: "<span style='font-size:11px'>{series.name}</span><br>",
//       pointFormat:
//         "<span style='color:{point.color}'>{point.name}</span>: <b>${point.y:.2f}</b><br/>",
//     },
//     series: [
//       {
//         name: "Procedure Type",
//         colorByPoint: false,
//         data: seriesData,
//       },
//     ],
//     drilldown: {
//       series: drilldownSeries,
//     },
//   };
// };

const Chart = () => {
  const [selectedMedicareType, setSelectedMedicareType] = useState("PFS");
  const [selectedCategory, setSelectedCategory] = useState(
    Object.keys(cignaData["PFS"])[0]
  );
  const [chartOptions, setChartOptions] = useState(
    getChartOptions("PFS", Object.keys(cignaData["PFS"])[0])
  );

  const chartComponentRef = useRef(null);

  useEffect(() => {
    const chart = chartComponentRef.current?.chart;

    // Drill up if chart is drilled down
    if (chart && chart.drillUp && chart.drilldownLevels?.length > 0) {
      while (chart.drilldownLevels.length > 0) {
        chart.drillUp();
      }
    }

    setChartOptions(getChartOptions(selectedMedicareType, selectedCategory));
  }, [selectedMedicareType, selectedCategory]);

  return (
    <div
      className="bg-white p-4"
      style={{ border: "none", borderRadius: "8px" }}
    >
      {/* Dropdowns */}
      <div className="mb-4 d-flex flex-row gap-3 align-items-center">
        {/* Medicare Type Dropdown */}
        <div>
          <label className="form-label">Select Medicare Type:</label>
          <select
            className="form-select"
            value={selectedMedicareType}
            onChange={(e) => {
              const newType = e.target.value;
              const defaultCategory = Object.keys(cignaData[newType])[0];
              setSelectedMedicareType(newType);
              setSelectedCategory(defaultCategory);
            }}
          >
            {Object.keys(cignaData).map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {/* Category Dropdown */}
        <div>
          <label className="form-label">Select Category:</label>
          <select
            className="form-select"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            {Object.keys(cignaData[selectedMedicareType]).map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Chart */}
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        ref={chartComponentRef}
      />
    </div>
  );
};

export default Chart;
